import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Container, Nav, Navbar } from "react-bootstrap";

// PAGES
import Home from "./Home";
import Contact from "./Contact";
import Services from "./Services";
import Dashboard from "./Dashboard";
import Blog from "./Blog";
import AdminLogin from "./AdminLogin"; // 👈 Dodaj admin login komponentu
import SalonSoftwareDemo from "./SalonSoftwareDemo";
import Footer from "./Footer";

function Navigation() {
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setExpanded(false);

  return (
    <Router>
      <Navbar
        expand="lg"
        expanded={expanded}
        sticky="top"
        className={`maniera-navbar ${scrolled ? "scrolled" : ""}`}
      >
        <Container>
          {/* Logo */}
          <Navbar.Brand as={Link} to="/" onClick={closeMenu} className="brand-logo">
            <img src="./img/logo.png" alt="Maniera Digital" className="nav-logo" />
          </Navbar.Brand>

          {/* Mobile toggle */}
          <Navbar.Toggle
            aria-controls="maniera-navbar-nav"
            onClick={() => setExpanded(!expanded)}
            className="custom-toggler"
          >
            {expanded ? (
              <span className="close-icon">×</span>
            ) : (
              <div className="hamburger-icon">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
              </div>
            )}
          </Navbar.Toggle>

          <Navbar.Collapse id="maniera-navbar-nav">
            <Nav className="ms-auto align-items-center">
              {[
                { path: "/", label: "Home" },
                { path: "/services", label: "Services" },
                { path: "/salon-software-demo", label: "Booking" },
                { path: "/dashboard", label: "Dashboard" },
                { path: "/blog", label: "Blog" },
                { path: "/contact", label: "Contact" },
              ].map((link) => (
                <Nav.Link
                  as={Link}
                  key={link.path}
                  to={link.path}
                  onClick={closeMenu}
                  className="nav-link-custom"
                >
                  {link.label}
                </Nav.Link>
              ))}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* ROUTES */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/salon-software-demo" element={<SalonSoftwareDemo />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin-login" element={<AdminLogin />} /> {/* 👈 Admin login ruta */}
      </Routes>

      <Footer />
    </Router>
  );
}

export default Navigation;